import { render, staticRenderFns } from "./PosSale.vue?vue&type=template&id=98f80566&scoped=true"
import script from "./PosSale.vue?vue&type=script&lang=js"
export * from "./PosSale.vue?vue&type=script&lang=js"
import style0 from "./PosSale.vue?vue&type=style&index=0&id=98f80566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f80566",
  null
  
)

export default component.exports